import { render } from "./tw-form-view.vue?vue&type=template&id=0552caa6"
import script from "./tw-form-view.vue?vue&type=script&lang=js"
export * from "./tw-form-view.vue?vue&type=script&lang=js"
script.render = render

export default script